import {
  FETCHING_DEALS_FAILED,
  FETCHING_DEALS_SUCCEEDED,
  FETCHING_DEALS_REQUEST,
  FETCHING_DEALS_METRICS_REQUEST,
  FETCHING_DEALS_METRICS_SUCCEEDED,
  FETCHING_DEALS_METRICS_FAILED,
  FETCHING_DEAL_HISTORY_REQUEST,
  FETCHING_DEAL_HISTORY_SUCCEEDED,
  FETCHING_DEAL_HISTORY_FAILED,
  FETCHING_DEAL_TIMELINE_REQUEST,
  FETCHING_DEAL_TIMELINE_SUCCEEDED,
  FETCHING_DEAL_TIMELINE_FAILED,
  FETCHING_DEAL_SHARED_ASSETS_REQUEST,
  FETCHING_DEAL_SHARED_ASSETS_SUCCEEDED,
  FETCHING_DEAL_SHARED_ASSETS_FAILED,
  FETCHING_DEAL_SHARED_COLLECTIONS_REQUEST,
  FETCHING_DEAL_SHARED_COLLECTIONS_SUCCEEDED,
  FETCHING_DEAL_SHARED_COLLECTIONS_FAILED,
  FETCHING_DEAL_INSIGHTS_SIGNALS,
  FETCHING_DEAL_INSIGHTS_SIGNALS_SUCCEEDED,
  FETCHING_DEAL_INSIGHTS_SIGNALS_FAILED,  
  INVALIDATE_DEAL_INSIGHTS_SIGNALS,
  INVALIDATE_DEAL_INSIGHTS,
  FETCHING_DEAL_REQUEST,
  FETCHING_DEAL_SUCCEEDED,
  FETCHING_DEAL_FAILED,
  INVALIDATE_DEAL
} from "./actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url-ts";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const DEAL_INSIGHTS_BASE_URL = `${apiUrl}/api/2.0/deals`;

export function fetchActiveDeals(data, params) {
  return function (dispatch) {
    dispatch(fetchingDeals(FETCHING_DEALS_REQUEST));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/active`
    });

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: data
    })
      .then((response) =>
        dispatch(
          fetchingDealsSucceeded(FETCHING_DEALS_SUCCEEDED, response.data)
        )
      )
      .catch((error) =>
        dispatch(fetchingDealsFailed(FETCHING_DEALS_FAILED, error))
      );
  };
}

function fetchingDeals(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingDealsSucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealsFailed(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}

export function fetchDealsMetrics(params) {
  return function (dispatch) {
    dispatch(fetchingDealsMetrics(FETCHING_DEALS_METRICS_REQUEST));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/active/metrics`
    });

    return axios({
      method: "GET",
      url: url,
      params: params
    })
      .then((response) =>
        dispatch(
          fetchingDealsMetricsSucceeded(FETCHING_DEALS_METRICS_SUCCEEDED, response.data)
        )
      )
      .catch((error) =>
        dispatch(fetchingDealsMetricsFailed(FETCHING_DEALS_METRICS_FAILED, error))
      );
  };
}

function fetchingDealsMetrics(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingDealsMetricsSucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealsMetricsFailed(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}

export function fetchDealHistory(id, params) {
  return function (dispatch) {
    dispatch(fetchingDealHistory(FETCHING_DEAL_HISTORY_REQUEST));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/${id}/history`
    });

    return axios({
      method: "GET",
      url: url,
      params: params
    })
      .then((response) =>
        dispatch(
          fetchingDealHistorySucceeded(FETCHING_DEAL_HISTORY_SUCCEEDED, response.data)
        )
      )
      .catch((error) =>
        dispatch(fetchingDealHistoryFailed(FETCHING_DEAL_HISTORY_FAILED, error))
      );
  };
}

function fetchingDealHistory(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingDealHistorySucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealHistoryFailed(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}

export function fetchDealTimeline(id, params) {
  return function (dispatch) {
    dispatch(fetchingDealTimeline(FETCHING_DEAL_TIMELINE_REQUEST, params));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/${id}/timeline`
    });

    return axios({
      method: "GET",
      url: url,
      params: params
    })
      .then((response) =>
        dispatch(
          fetchingDealTimelineSucceeded(FETCHING_DEAL_TIMELINE_SUCCEEDED, response.data)
        )
      )
      .catch((error) =>
        dispatch(fetchingDealTimelineFailed(FETCHING_DEAL_TIMELINE_FAILED, error))
      );
  };
}

function fetchingDealTimeline(type, payload) {
  return {
    type: type,
    payload: payload,
  };
}

function fetchingDealTimelineSucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealTimelineFailed(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}

export function fetchDealSharedAssets(id, page) {
  return function (dispatch) {
    dispatch(fetchingDealSharedAssets(FETCHING_DEAL_SHARED_ASSETS_REQUEST, page));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/${id}/shared/assets`
    });

    return axios({
      method: "GET",
      url: url,
      params:{
        page,
        limit: 20
      }
    })
      .then((response) =>
        dispatch(
          fetchingDealSharedAssetsSucceeded(FETCHING_DEAL_SHARED_ASSETS_SUCCEEDED, response.data)
        )
      )
      .catch((error) =>
        dispatch(fetchingDealSharedAssetsFailed(FETCHING_DEAL_SHARED_ASSETS_FAILED, page, error))
      );
  };
}

function fetchingDealSharedAssets(type, page) {
  return {
    type: type,
    payload: {
      page
    },
  };
}

function fetchingDealSharedAssetsSucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealSharedAssetsFailed(type, page, error) {
  return {
    type: type,
    payload: {
      error: error,
      page
    },
  };
}

export function fetchDealSharedCollections(id) {
  return function (dispatch) {
    dispatch(fetchingDealSharedCollections(FETCHING_DEAL_SHARED_COLLECTIONS_REQUEST));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/${id}/shared/collections`
    });

    return axios({
      method: "GET",
      url: url
    }).then((response) =>
      dispatch(
        fetchingDealSharedCollectionsSucceeded(FETCHING_DEAL_SHARED_COLLECTIONS_SUCCEEDED, response.data)
      )
    ).catch((error) =>
      dispatch(fetchingDealSharedCollectionsFailed(FETCHING_DEAL_SHARED_COLLECTIONS_FAILED, error))
    );
  };
}

function fetchingDealSharedCollections(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingDealSharedCollectionsSucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealSharedCollectionsFailed(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}

export function fetchDealInsightsSignals(id, page) {
  return function (dispatch) {
    dispatch(fetchingDealInsightsSignals(FETCHING_DEAL_INSIGHTS_SIGNALS, page, id));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/signals/${id}`,
      queryParams:{
        page: page
      }
    });

    return axios({
      method: "GET",
      url: url
    }).then((response) =>
      dispatch(
        fetchingDealInsightsSignalsSucceeded(FETCHING_DEAL_INSIGHTS_SIGNALS_SUCCEEDED, id, response.data)
      )
    ).catch((error) =>
      dispatch(fetchingDealInsightsSignalsFailed(FETCHING_DEAL_INSIGHTS_SIGNALS_FAILED, id, error))
    );
  }

}

function fetchingDealInsightsSignals(type, page, id) {
  return {
    type: type,
    payload: { page, id },
  };
}


function fetchingDealInsightsSignalsSucceeded(type, id, json) {
  return {
    type: type,
    payload: {
      id,
      data : json
    },
  };
}

function fetchingDealInsightsSignalsFailed(type, id, error) {
  return {
    type: type,
    payload: {
      id,
      error,
    },
  };
}

export function invalidateDealInsightsSignals() {
  return {
    type: INVALIDATE_DEAL_INSIGHTS_SIGNALS
  };
}

export function invalidateDealInsights(){
  return {
    type : INVALIDATE_DEAL_INSIGHTS
  }
}

export function fetchDeal(id) {
  return function (dispatch) {
    dispatch(fetchingDeal(FETCHING_DEAL_REQUEST));

    var url = buildUrl(DEAL_INSIGHTS_BASE_URL, {
      path: `/${id}`
    });

    return axios({
      method: "GET",
      url: url
    })
      .then((response) =>
        dispatch(
          fetchingDealSucceeded(FETCHING_DEAL_SUCCEEDED, response.data)
        )
      )
      .catch((error) =>
        dispatch(fetchingDealFailed(FETCHING_DEAL_FAILED, error))
      );
  };
}

function fetchingDeal(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingDealSucceeded(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingDealFailed(type, error) {
  return {
    type: type,
    payload: {
      error: error,
    },
  };
}

export function invalidateDeal(){
  return {
    type : INVALIDATE_DEAL
  }
}
